module.exports = __webpack_public_path__ + "assets/on-ride.8e4567df.svg";